import { render, staticRenderFns } from "./Bucket.vue?vue&type=template&id=29971054&scoped=true&"
import script from "./Bucket.vue?vue&type=script&lang=js&"
export * from "./Bucket.vue?vue&type=script&lang=js&"
import style0 from "./Bucket.scss?vue&type=style&index=0&id=29971054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29971054",
  null
  
)

export default component.exports